import { SwgyHeaderKeysList } from "@swiggy-private/checkout-types";

import { X_CART_TYPE } from "@checkout-core/constants/MROCart";
import { GlobalHeaderState } from "@checkout-core/utils/Headers";

/**
 * Cart types that participate in the quick-checkout (compact webview) flow.
 * AIP is the only onboarded type today; keep this a list so more can join later.
 */
const QUICK_CHECKOUT_X_CART_TYPES: X_CART_TYPE[] = [X_CART_TYPE.AIP];
export const NOOP_OBJECT = {};

/**
 * Detects the quick-checkout flow from `x-cart-type`.
 *
 * Prefer `x-cart-type` over URL `state` — redirections drop/change the path query,
 * while headers remain stable for the same native session.
 *
 * Pass `headers` when GlobalHeaderState is not yet available (e.g. CheckoutApp
 * bootstrap / server middleware). Otherwise reads from GlobalHeaderState.
 */
export const isQuickCheckoutFlow = (headers?: { [header: string]: string | undefined }): boolean => {
    const xCartType = (
        (headers ? headers["x-cart-type"] : GlobalHeaderState.getHeader(SwgyHeaderKeysList.xCartType)) || ""
    ).toLowerCase();
    return QUICK_CHECKOUT_X_CART_TYPES.includes(xCartType as X_CART_TYPE);
};

export const isAipFlow = (headers?: { [header: string]: string | undefined }): boolean => {
    const xCartType = (
        (headers ? headers["x-cart-type"] : GlobalHeaderState.getHeader(SwgyHeaderKeysList.xCartType)) || ""
    ).toLowerCase();
    return xCartType === X_CART_TYPE.AIP;
};

const QUICK_CHECKOUT_HTML_CLASS = "quick-checkout";

/**
 * Toggles the transparent page background that lets the native screen show through behind the
 * compact quick-checkout sheet.
 */
export const setQuickCheckoutBackgroundTransparent = (transparent: boolean): void => {
    if (typeof document === "undefined") {
        return;
    }
    document.documentElement.classList.toggle(QUICK_CHECKOUT_HTML_CLASS, transparent);
};
